import styled, { css } from 'styled-components';
import { Box } from '@rebass/grid';

import { media } from 'app/shared/styles_js/variables';

export const GridContainerSt = styled.div`
  display: grid;

  ${media.md(css`
    grid-column-gap: 32px;
    grid-template-columns: repeat(2, 1fr);
  `)}
`;

// eslint-disable-next-line prettier/prettier
export const ImageContainerSt = styled(Box)<{ imageSrc: string; gridPosition: boolean;}>`
  min-height: 324px;
  background-image: url(${({ imageSrc }) => imageSrc});
  background-size: cover;
  background-position-x: center;
  background-position-y: center;
  ${({ gridPosition }) =>
    media.md(
      gridPosition
        ? css`
            grid-row: 1;
          `
        : '',
    )}
`;
